export enum TaskStatusDefinitionEnum {
  Hold = 1,
  Unallocated = 2,
  AwaitingStart = 3,
  CollectionHeaded = 4,
  CollectionArrived = 5,
  AwaitingRelease = 6,
  CollectionInspection = 7,
  CollectionHandover = 8,
  MovementStarted = 9,
  MovementEnded = 10,
  DeliveryInspection = 11,
  DeliveryHandover = 12,
  MovementComplete = 13,
  MovementAborted = 14,
  MovementCancelled = 15,
  Break = 16,
  OvernightParked = 17,
  Charging = 18,
  Fueling = 19,
  Breakdown = 20,
  CarWash = 21,
  Parked = 22,
  WaitingAuthCollection = 23,
  WaitingRelease = 24,
  WaitingAuthDelivery = 25,
}
